import {getCategories} from '../api/categories';
import {getPaymentAccounts} from '../api/paymentAccounts';
import {getTags} from '../api/tags';
import {formatTransactionCategory} from '../formatters';
import {stringify} from 'csv-stringify/browser/esm/sync';
import {saveAs} from 'file-saver';
import {keyBy} from 'shared/src/map';
import {type Transaction} from 'shared/src/models';

const CSV_HEADERS = ['Date', 'Payment Account', 'Payee', 'Category', 'Memo', 'Amount', 'Tags'];

export const downloadTransactionCsv = async (
	transactions: Transaction[],
	filename: string,
): Promise<void> => {
	const accounts = keyBy(await getPaymentAccounts(), (account) => account.id);
	const tags = keyBy(await getTags(), (tag) => tag.id);
	const categories = await getCategories();

	const csvData = transactions.map((transaction) => {
		return [
			transaction.date,
			accounts.get(transaction.paymentAccount)?.name,
			transaction.payee,
			formatTransactionCategory(categories.get(transaction.category)!),
			transaction.memo,
			(transaction.amount / 100).toFixed(2),
			transaction.tags.map((tag) => tags.get(tag)).join(', '),
		];
	});

	const csvString = stringify([CSV_HEADERS, ...csvData]);

	const blob = new Blob([csvString], {type: 'text/csv;charset=utf-8'});

	saveAs(blob, filename);
};
